var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2024 2.54494C11.5076 1.81835 12.4924 1.81835 12.7976 2.54494L15.0171 7.82918C15.1435 8.13023 15.415 8.3367 15.7276 8.36955L21.2146 8.9462C21.9691 9.02549 22.2734 10.0059 21.7076 10.5342L17.5923 14.3767C17.3578 14.5956 17.2541 14.9297 17.3209 15.251L18.4925 20.8917C18.6536 21.6673 17.8569 22.2732 17.202 21.8731L12.4391 18.9637C12.3035 18.8808 12.1517 18.8394 12 18.8394C11.8483 18.8394 11.6965 18.8808 11.5609 18.9637L6.79798 21.8731C6.14308 22.2732 5.34636 21.6673 5.50746 20.8917L6.67911 15.251C6.74587 14.9297 6.64216 14.5956 6.40771 14.3767L2.29243 10.5342C1.72658 10.0059 2.0309 9.02549 2.78537 8.9462L8.27237 8.36955C8.58497 8.3367 8.85647 8.13023 8.98292 7.82918L11.2024 2.54494Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.beb951c04922e284e6dccfe91a7f8f41.svg";
export { ForwardRef as ReactComponent };